import NextImage from 'next/image'

import house from '../images/house-img.png'
import classes from './left-section.module.css'

export const LeftSection = () => {
  return (
    <div className={classes.leftSectionWrapper}>
      <NextImage
        src={house.src}
        sizes="100vw"
        style={{
          width: '100%',
          height: 'auto',
        }}
        alt="Home with REZITRADE is a simple and convenient asset"
        width={745}
        height={745}
        className={classes.houseImg}
      />
      <p className={classes.footnotes}>
        *Discount applies to the first year contract, with a maximum of $200 off. Offer is only
        available to new customers and cannot be combined with any other offers.
      </p>
    </div>
  )
}
